import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { HelpModalProvider } from './providers/HelpModalProvider';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import InjectAxiosInterceptors from 'layout/InjectAxiosInterceptors';

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <SnackbarProvider maxSnack={1}>
                <ThemeProvider theme={themes(customization)}>
                    <HelpModalProvider>
                        <CssBaseline />
                        <NavigationScroll>
                            <InjectAxiosInterceptors />
                            <Routes />
                        </NavigationScroll>
                    </HelpModalProvider>
                </ThemeProvider>
            </SnackbarProvider>
        </StyledEngineProvider>
    );
};

export default App;
